<template>
  <div class="ge_main">
    <img class="bg_img" src="/static/hd/ganen/hd_bg_pc.jpg" alt="" >
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HuoDongGanenPc',
  components: {
  },
  data: () => {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style scoped>
.ge_main {
  margin-top: 64px;
}
.bg_img {
  width: 80%;
}
</style>
